import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { Form, Button, Row, Col, Table, Badge, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import Message from "../components/Message";
import Loader from "../components/Loader";
import { getUserDetails , updateUserProfile } from "../actions/userActions";
import { listMyOrders } from "../actions/orderActions";
import { USER_UPDATE_PROFILE_RESET } from "../constants/userConstants";

function ProfileScreen() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const userDetails = useSelector(state => state.userDetails);
    const { loading, error, user } = userDetails;

    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    const userUpdateProfile = useSelector(state => state.userUpdateProfile);
    const { success } = userUpdateProfile;

    const [saveSuccess, setSaveSuccess] = useState(false);

    const orderListMy = useSelector(state => state.orderListMy);
    const { loading: loadingOrders, error: errorOrders, orders } = orderListMy;

    useEffect(() => {
        if (!userInfo) {
            navigate('/login');
        }
        else {
            if (!user || !user.name || success) {
                dispatch({ type: USER_UPDATE_PROFILE_RESET });
                dispatch(getUserDetails('profile'));
                dispatch(listMyOrders());
            } else {
                setName(user.name);
                setEmail(user.email);
              setPhoneNumber(user.phone_number || '');
            }
        }
    }, [navigate, userInfo, dispatch, user, success]);


    function submitHandler(e) {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage(t('profile.passwordMismatch'));
        } else {
            setSaveSuccess(false);
            dispatch(updateUserProfile({ id: user._id, name, email, phone_number: phoneNumber, password }));
            setSaveSuccess(true);
            setPassword("");
            setConfirmPassword("");
        }
    }

    
  return (
    <Row>
      <Col md={3}>
        <h2>{t('profile.title')}</h2>

      {message && <Message variant="danger">{message}</Message>}
      {error && <Message variant="danger">{error}</Message>}
      {saveSuccess && <Alert variant="success" dismissible onClose={() => setSaveSuccess(false)}>{t('profile.updated')}</Alert>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="name" className="mb-3">
          <Form.Label>{t('profile.name')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('profile.enterName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="email" className="mb-3">
          <Form.Label>{t('profile.email')}</Form.Label>
          <Form.Control
            required
            type="email"
            placeholder={t('profile.enterEmail')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="phoneNumber" className="mb-3">
          <Form.Label>{t('profile.phone')}</Form.Label>
          <Form.Control
            type="tel"
            placeholder={t('profile.phonePlaceholder')}
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="password" className="mb-3">
          <Form.Label>{t('profile.password')}</Form.Label>
          <Form.Control
            type="password"
            placeholder={t('profile.passwordPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="confirmPassword" className="mb-3">
          <Form.Label>{t('profile.confirmPassword')}</Form.Label>
          <Form.Control
            type="password"
            placeholder={t('profile.confirmPasswordPlaceholder')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Button type="submit" variant="primary" className="mt-2">
          {t('profile.update')}
        </Button>
      </Form>
      

        </Col>      <Col md={9}>
        <h2>{t('profile.myOrders')}</h2>
        {loadingOrders ? (
          <Loader />
        ) : errorOrders ? (
          <Message variant='danger'>{errorOrders}</Message>
        ) : orders && orders.length === 0 ? (
          <Message variant='info'>{t('profile.noOrders')}</Message>
        ) : (
          <>
            <Table striped bordered hover responsive className='table-sm'>
              <thead>
                <tr>
                  <th>{t('profile.orderId')}</th>
                  <th>{t('profile.date')}</th>
                  <th>{t('profile.total')}</th>
                  <th>{t('profile.paidHeader')}</th>
                  <th>{t('profile.deliveredHeader')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders && orders.slice(0, 5).map((order) => (
                  <tr key={order.OrderId}>
                    <td>#{order.OrderId}</td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                    <td>{order.total_price} DKK</td>
                    <td>
                      {order.is_paid ? (
                        <Badge bg="success">{t('profile.paid')}</Badge>
                      ) : (
                        <Badge bg="warning" text="dark">{t('profile.pending')}</Badge>
                      )}
                    </td>
                    <td>
                      {order.is_delivered ? (
                        <Badge bg="success">{t('profile.delivered')}</Badge>
                      ) : (
                        <Badge bg="secondary">{t('profile.processing')}</Badge>
                      )}
                    </td>
                    <td>
                      <LinkContainer to={`/order/${order.OrderId}`}>
                        <Button className='btn-sm' variant='outline-primary'>
                          {t('profile.viewOrder')}
                        </Button>
                      </LinkContainer>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {orders && orders.length > 5 && (
              <div className="text-center mt-3">
                <LinkContainer to='/orders'>
                  <Button variant='primary'>
                    {t('profile.viewAllOrders', { count: orders.length })}
                  </Button>
                </LinkContainer>
              </div>
            )}
            {orders && orders.length <= 5 && orders.length > 0 && (
              <div className="text-center mt-3">
                <LinkContainer to='/orders'>
                  <Button variant='outline-primary'>
                    {t('profile.viewOrderHistory')}
                  </Button>
                </LinkContainer>
              </div>
            )}
          </>
        )}
      </Col>
    </Row>
  );
}





export default ProfileScreen;